//@flow
import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import Section from "./Section"
import { Flex, Box } from "grid-styled"
import { Page, LayerStack } from "../UI/Page"
import { Toolbar, Heading } from "../UI/Toolbar"
import { NavLink, Icon } from "../UI/Sidebar"
import { PrimaryButton } from "../UI/Buttons"
import KiosksSection from "./KiosksSection"
import SensorsSection from "./SensorsSection"
import UsersSection from "./UsersSection"
import type { RouterHistory, Match } from "react-router-dom"
import type { IntlShape } from "react-intl"

const FlexBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  & > * {
    display: block;
    margin: 0.5rem;
  }
`

type SectionContents = {
  icon: string,
  name: string,
  route: string
}

const sections: Array<SectionContents> = [
  { icon: "🖥", name: "kiosks", route: "/admin/kiosks" },
  { icon: "👥", name: "users", route: "/admin/kiosks" }
]

const Home = ({
  history: { push },
  match,
  intl: { formatMessage }
}: {
  history: RouterHistory,
  match: Match,
  intl: IntlShape
}) => (
  <Page>
    <Helmet>
      <title>
        {`${formatMessage({ id: "admin.title" })} - ${formatMessage({
          id: "admin.dashboard.title"
        })}`}
      </title>
    </Helmet>

    <Toolbar>
      <Heading>
        <FormattedMessage id={`admin.dashboard.title`} />
      </Heading>
    </Toolbar>

    <Flex wrap>
      {sections.map(({ name, icon, route }) => (
        <Box w={[1, 1, 1 / 3]} p={[0, 0, 1]} key={name}>
          <Section>
            <FlexBlock>
              <Icon
                aria-label={formatMessage({
                  id: `admin.dashboard.${name}.title`
                })}
              >
                {icon}
              </Icon>
              <PrimaryButton onClick={() => push(`${route}/new`)}>
                <FormattedMessage
                  id={`admin.dashboard.${name}.newButtonText`}
                />
              </PrimaryButton>
              <NavLink to={route}>
                <FormattedMessage id={`admin.dashboard.${name}.viewAll`} />
              </NavLink>
            </FlexBlock>
          </Section>
        </Box>
      ))}
    </Flex>
    <LayerStack>
      <KiosksSection push={push} />
      <SensorsSection push={push} />
      <UsersSection push={push} />
    </LayerStack>
  </Page>
)

export default injectIntl(Home)



// WEBPACK FOOTER //
// ./src/Home/index.js